import React, { FC, useEffect } from 'react';
import { GoBackBtn } from '../header/GoBackBtn';
import { StatusBadge } from '../status/StatusBadge';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { STATUSES } from '../../views/login/Login';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { EditStatus } from '../merchants/EditStatus';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { useLocation } from 'react-router';
import { APPLICATION_DETAILS_NAVIGATION } from '../../constants/application-details/application-details-navigation';
import { setApplicationEditStatus } from '../../store/merchnts/actions/application';

export const ApplicationDetailsHeader: FC = () => {
  const { t } = useTranslation();
  const { merchantState: { applicationData, applicationFormEditStatus }, dispatch } = useMerchants();
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (pathname.includes(APPLICATION_DETAILS_NAVIGATION.FORM)!) {
      setApplicationEditStatus({ dispatch, value: false });
    }
  }, [pathname]);

  return (
    <div className="mb-10">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center justify-content-between justify-content-sm-start">
        <GoBackBtn path={`/accounts/applications${state?.search || '' }`} />
          {
            applicationData?.statusName !== STATUSES.CANCELLED
            && applicationData?.statusName !== STATUSES.DECLINED
            && applicationData?.statusName !== STATUSES.SUBMITTED
            && checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN)
            && pathname.includes(APPLICATION_DETAILS_NAVIGATION.FORM)
            && !applicationFormEditStatus
            && (
              <EditStatus
                formEditStatus={applicationFormEditStatus}
                onSaveClick={(): void => setApplicationEditStatus({ dispatch, value: !applicationFormEditStatus })}
                // loading={loading}
              />
            )
          }
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-center">
            <span className="fs-5 text-muted">
              {t('NEW_APPLICATION.STATUS')}
            </span>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <span
              className="h-30px border-gray-500 border-2 border-start mx-4"
              style={{ borderColor: '#8E8E93' }}
            />
          </div>
          <StatusBadge status={applicationData?.statusName} additionalClasses="fs-5 bg-transparent p-0 me-5" />
        </div>
      </div>
    </div>
  );
};